import { useLang } from 'hooks/lang';

import { Tooltip } from 'components/Blocks';
import { CalendarIcon } from 'components/Icons';

import { useProjectOption } from '../ProjectOptions';
import { useProjectProfile } from '../context';

import { getDateWithMonthText, getReadableDate } from 'utils/date';
import { useIsBreakpoint } from 'hooks';

export function ProjectDate() {
  const { t } = useLang();

  const { project } = useProjectProfile();

  const changeDate = useProjectOption('CHANGE_DATE');

  const isPhone = useIsBreakpoint('PHONE');

  const format = isPhone ? getDateWithMonthText : getReadableDate;

  if (project?.canceledAt) {
    return (
      <p className="text-lg font-medium text-destructive">
        {t('canceled-at')}: {format(new Date(project.canceledAt))}
      </p>
    );
  }

  if (!project?.expectedDate) return null;

  const dateString = project?.expectedDate && format(new Date(project.expectedDate));

  const disabled = !changeDate.isEnabled;

  return (
    <Tooltip content={disabled ? t('final-date') : t('change-date')}>
      <button
        disabled={disabled}
        onClick={changeDate.action}
        className="inline-flex items-center gap-2 rounded-sm bg-primary-light px-3 py-0.5 text-primary-foreground transition-colors hover:bg-primary"
      >
        <span>{dateString}</span>

        <CalendarIcon />
      </button>
    </Tooltip>
  );
}
